// hisaab · agent · hook
// Empire-Self ambient tile. Disabled by default, opt-in via Settings.
// Source: chassis/src/agent/proactive-rules.ts (swiggy.spike). DPDP scope: read.spend.

export interface AgentHookInsight {
  readonly headline: string;
  readonly priority: 1 | 2 | 3;
}

export type AgentSnapshot = Record<string, unknown>;

const STORAGE_KEY = "hisaab-empire-self-enabled";
const APP_SLUG = "hisaab";
const SCOPE = "read.spend";

export function isEnabled(): boolean {
  if (typeof localStorage === "undefined") return false;
  return localStorage.getItem(STORAGE_KEY) === "1";
}

export function setEnabled(v: boolean): void {
  if (typeof localStorage === "undefined") return;
  if (v) localStorage.setItem(STORAGE_KEY, "1");
  else localStorage.removeItem(STORAGE_KEY);
}

export function getMockSnapshot(): AgentSnapshot {
  return {"swiggy_weekly_paise": 240000, "swiggy_weekly_paise_prev": 110000};
}

function evaluate(s: AgentSnapshot): AgentHookInsight | null { 
  const w = (s.swiggy_weekly_paise as number | undefined) ?? 0;
  const prev = (s.swiggy_weekly_paise_prev as number | undefined) ?? 0;
  if (prev === 0 || w / prev < 1.8) return null;
  return {
    headline: `swiggy spend ${(w / prev).toFixed(1)}x baseline this week (₹${(w / 100).toFixed(0)} vs ₹${(prev / 100).toFixed(0)})`,
    priority: 2,
  };
}

const EM_DASH = /[—–]/;
const EMOJI = /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u;

function toneOk(text: string): boolean {
  if (!text.trim()) return false;
  if (EM_DASH.test(text)) return false;
  if (EMOJI.test(text)) return false;
  return text.length <= 220;
}

export function renderTile(host: HTMLElement, snapshot: AgentSnapshot = getMockSnapshot()): void {
  host.innerHTML = "";
  if (!isEnabled()) return;
  const insight = evaluate(snapshot);
  if (!insight || !toneOk(insight.headline)) return;
  const wrap = document.createElement("aside");
  wrap.setAttribute("role", "status");
  wrap.setAttribute("aria-live", "polite");
  wrap.dataset.priority = String(insight.priority);
  wrap.dataset.app = APP_SLUG;
  wrap.dataset.scope = SCOPE;
  wrap.className = "empire-self-tile";
  const kicker = document.createElement("b");
  kicker.textContent = "empire-self";
  const body = document.createElement("p");
  body.textContent = insight.headline;
  wrap.append(kicker, body);
  host.append(wrap);
}

export function mountAmbient(): void {
  if (typeof document === "undefined") return;
  let host = document.getElementById("empire-self-tile");
  if (!host) {
    host = document.createElement("section");
    host.id = "empire-self-tile";
    host.dataset.app = APP_SLUG;
    document.body.prepend(host);
  }
  renderTile(host, getMockSnapshot());
}
